<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">
        <!-- logo -->
        <b-link class="brand-logo">
          <!-- <vuexy-logo /> -->
          <b-img :src="appLogoImage" alt="logo" />
          <!-- <h2 class="brand-text text-primary ml-1">
            Vuexy
          </h2> -->
        </b-link>

        <b-card-title class="mb-1">
          {{ $t("auth.changePassword") }} 🔒
        </b-card-title>
        <!-- <b-card-text class="mb-2">
          Your new password must be different from previously used passwords
        </b-card-text> -->

        <!-- form -->
        <!-- <validation-observer ref="simpleRules"> -->
        <b-form method="POST" class="auth-reset-password-form mt-2">
          <!--old password -->
          <b-form-group
            :label="$t('auth.oldPassword')"
            label-for="reset-password-old"
            :invalid-feedback="
              invalidFeedbackOldPassword
                ? $t(`validation.${invalidFeedbackOldPassword}`, {
                    field: $t('auth.oldPassword'),
                  })
                : ''
            "
            :state="$v.oldPassword.$dirty ? !$v.oldPassword.$invalid : null"
          >
            <!-- <validation-provider
                #default="{ errors }"
                name="Password"
                vid="Password"
                rules="required|password"
              > -->
            <b-input-group
              class="input-group-merge"
              :class="
                invalidFeedbackOldPassword.length > 0 ? 'is-invalid' : null
              "
            >
              <b-form-input
                id="reset-password-old"
                v-model="oldPassword"
                :type="passwordFieldType"
                :state="$v.oldPassword.$dirty ? !$v.oldPassword.$invalid : null"
                class="form-control-merge"
                name="reset-password-old"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
          <b-form-group
            :label="$t('auth.newPassword')"
            label-for="reset-password-new"
            :invalid-feedback="
              invalidFeedbackPassword
                ? $t(`validation.${invalidFeedbackPassword}`, {
                    field: $t('auth.password'),
                    min: 6,
                  })
                : ''
            "
            :state="$v.password.$dirty ? !$v.password.$invalid : null"
          >
            <!-- <validation-provider
                #default="{ errors }"
                name="Password"
                vid="Password"
                rules="required|password"
              > -->
            <b-input-group
              class="input-group-merge"
              :class="invalidFeedbackPassword.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="reset-password-new"
                v-model="password"
                :type="password1FieldType"
                :state="$v.password.$dirty ? !$v.password.$invalid : null"
                class="form-control-merge"
                name="reset-password-new"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password1ToggleIcon"
                  @click="togglePassword1Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>

          <!-- confirm password -->
          <b-form-group
            label-for="reset-password-confirm"
            :label="$t('auth.confirmation')"
            :invalid-feedback="
              invalidFeedbackConfirmation
                ? $t(`validation.${invalidFeedbackConfirmation}`, {
                    current: $t('auth.confirmation'),
                    field: $t('auth.password'),
                  })
                : ''
            "
            :state="$v.confirmation.$dirty ? !$v.confirmation.$invalid : null"
          >
            <!-- <validation-provider
                #default="{ errors }"
                name="Confirm Password"
                rules="required|confirmed:Password"
              > -->
            <b-input-group
              class="input-group-merge"
              :class="
                invalidFeedbackConfirmation.length > 0 ? 'is-invalid' : null
              "
            >
              <b-form-input
                id="reset-password-confirm"
                :state="
                  $v.confirmation.$dirty ? !$v.confirmation.$invalid : null
                "
                v-model="confirmation"
                :type="password2FieldType"
                class="form-control-merge"
                name="reset-password-confirm"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password2ToggleIcon"
                  @click="togglePassword2Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>

          <!-- submit button -->
          <b-button block @click="changePassword" variant="primary">
            {{ $t("general.submit") }}
          </b-button>
        </b-form>
        <!-- </validation-observer> -->

        <p class="text-center mt-2">
          <b-link :to="{ name: 'profile' }">
            <feather-icon icon="ChevronLeftIcon" />
            {{ $t("auth.backToProfile") }}
          </b-link>
        </p>
      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>
</template>

<script>
import { $themeConfig } from "@themeConfig";

// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard,
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BFormInput,
  BButton,
  BImg,
} from "bootstrap-vue";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // VuexyLogo,
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    BImg,
    // ValidationProvider,
    // ValidationObserver,
  },
  validations() {
    return {
      password: {
        required,
        minLength: minLength(6),
      },
      oldPassword: {
        required,
      },
      confirmation: {
        sameAsPassword: sameAs("password"),
      },
    };
  },
  data() {
    return {
      // userEmail: "",
      // cPassword: "",
      // password: "",
      // validation
      // Toggle Password
      password1FieldType: "password",
      password2FieldType: "password",
      passwordFieldType: "password",
    };
  },
  computed: {
    password: {
      set(password) {
        this.$store.commit("auth/SET_PASSWORD", password);
      },
      get() {
        return this.$store.getters["auth/password"];
      },
    },
    oldPassword: {
      set(oldPassword) {
        this.$store.commit("auth/SET_OLD_PASSWORD", oldPassword);
      },
      get() {
        return this.$store.getters["auth/oldPassword"];
      },
    },
    confirmation: {
      set(confirmation) {
        this.$store.commit("auth/SET_CONFIRMATION", confirmation);
      },
      get() {
        return this.$store.getters["auth/confirmation"];
      },
    },
    invalidFeedbackOldPassword: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.oldPassword.$dirty) return error;
        if (!this.$v.oldPassword.required) error = "required";
        return error;
      },
    },
    invalidFeedbackPassword: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.password.$dirty) return error;
        if (!this.$v.password.required) error = "required";
        if (!this.$v.password.minLength) error = "min";
        return error;
      },
    },
    invalidFeedbackConfirmation: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.confirmation.sameAsPassword) error = "sameAs";
        return error;
      },
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          newPassword: this.password,
          oldPassword: this.oldPassword,
        };
        this.$store.dispatch("auth/changePassword", payload).then(() => {
          this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
            // title: this.$t('toastification.success'),
            variant: 'success',
            solid: true,
          });
        }).catch(()=>{
          this.$bvToast.toast(this.$t('toastification.submissionFailed'), {
            variant: 'danger',
            solid: true,
          });
        })
      }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
      // this.$refs.simpleRules.validate().then(success => {
      // if (success) {
      // this.$toast({
      // component: ToastificationContent,
      // props: {
      //   title: 'Form Submitted',
      //   icon: 'EditIcon',
      //   variant: 'success',
      // },
      // })
      // }
      // })
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
